<div class="text-center mt-5">
  <fgb-loading></fgb-loading>
  <p class="mt-2 mb-0"><em [translate]="'subscriptions.payment-processing'">Payment processing...</em></p>
</div>
